var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cont"}},[_c('div',{class:{'visible': _vm.isActive, 'hidden': _vm.notActive},attrs:{"id":"colored"}},[_vm._v(" "+_vm._s(_vm.lowerCaseTitle)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }